import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-file\">\n    <path fill=\"#4F8BFF\" fill-rule=\"evenodd\" d=\"M1 2h7l1.207 1.996H15c.552 0 1 .448 1 1V13c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol